export type AppExperienceMode = 'mobile-pwa' | 'mobile-browser' | 'desktop-web';

export function isStandaloneDisplayMode(win: Window = window) {
  const nav = win.navigator as Navigator & { standalone?: boolean };
  return win.matchMedia('(display-mode: standalone)').matches || nav.standalone === true;
}

export function resolveAppExperienceMode(win: Window = window): AppExperienceMode {
  const isMobileViewport = win.matchMedia('(max-width: 767px)').matches;
  const isCoarsePointer = win.matchMedia('(pointer: coarse)').matches;
  const isMobile = isMobileViewport || isCoarsePointer;

  if (!isMobile) {
    return 'desktop-web';
  }

  return isStandaloneDisplayMode(win) ? 'mobile-pwa' : 'mobile-browser';
}

export function appExperienceModeClassName(mode: AppExperienceMode) {
  return `app-experience-${mode}`;
}
